import React from 'react'
import { connect } from 'react-redux'
import { getFormValue } from '../../public/utility'
import BonusApplicationDeatil from './BonusApplicationDeatil'
class SelectSalaryIssueDiv extends React.Component {
    state = {
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    componentDidMount = () => {
        this.doGetSalaryIssue()
    }

    doGetSalaryIssue = () => {
        const { dispatch, id } = this.props
        Tyan.doPostEvent({
            event: 'GetSalaryIssue',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerConfirm = () => {
        const { onSave, onClose, id, showDetail } = this.props
        const { changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveSalaryIssue',
            data: {
                id,
                changedValues基本信息: values
            },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                onClose && onClose()
                onSave && onSave()
            }
        })
    }

    handlerClose = () => {
        const { onClose, onSave } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return values.薪资期号
    }

    fieldset基本信息 = () => {
        return [
            { _select: '发放月份', name: '薪资期号' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const canSave = this.canSave()
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(SelectSalaryIssueDiv)